import React, { useEffect } from 'react';
import { Container, Spinner } from 'reactstrap';
import useMemoryGameStore from '../../store/memoryGameStore';
import { useIsMemoryGameActive } from '../../store/configStore';
import { useRegisterFocusMode, FocusModePriority } from '../../store/focusModeStore';
import GameHeader from './components/GameHeader';
import MemoryBoard from './components/MemoryBoard';
import FactModal from './components/FactModal';
import GoldenModal from './components/GoldenModal';
import WinModal from './components/WinModal';
import styles from './MemoryGameContainer.module.scss';

const MemoryGameContainer = ({ style = {} }) => {
    const isMemoryGameActive = useIsMemoryGameActive();
    
    useRegisterFocusMode('memoryGame', FocusModePriority.COMPONENT, false, true, isMemoryGameActive);

    const {
        cards,
        matchedPairsCount,
        totalPairsCount,
        attempts,
        activeFact,
        goldenFact,
        isGameCompleted,
        isGoldenModalOpen,
        hasTicket,
        config,
        loading,
        announcement,
        fetchGameData,
        flipCard,
        closeFactModal,
        closeGoldenModal,
        redeemTicket,
        resetGame,
    } = useMemoryGameStore();

    useEffect(() => {
        if (isMemoryGameActive) {
            fetchGameData();
        }
    }, [fetchGameData, isMemoryGameActive]);

    if (!isMemoryGameActive) {
        return null;
    }

    if (loading) {
        return (
            <Container className="text-center py-5" style={style}>
                <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
                <p className="mt-3 text-muted">Spieldaten werden geladen...</p>
            </Container>
        );
    }

    return (
        <div className={styles.gameContainer} style={style}>
            <GameHeader headline={config?.headline} introText={config?.introText} />

            <MemoryBoard
                cards={cards}
                onFlipCard={flipCard}
                matchedPairsCount={matchedPairsCount}
                totalPairsCount={totalPairsCount}
                attempts={attempts}
                hasTicket={hasTicket}
                goldenFact={goldenFact}
                onRedeemTicket={redeemTicket}
                announcement={announcement}
                placeholderIconName={config?.placeholderIconName}
                placeholderIconSize={config?.placeholderIconSize}
                placeholderIconColor={config?.placeholderIconColor}
                cardBackIconName={config?.cardBackIconName}
                cardBackIconSize={config?.cardBackIconSize}
                cardIconSize={config?.cardIconSize}
                cardColorType={config?.cardColorType}
                cardCustomColor={config?.cardCustomColor}
            />

            <FactModal factData={activeFact} onClose={closeFactModal} backdropClassName={styles.gameModalBackdrop} />

            <GoldenModal
                isOpen={isGoldenModalOpen}
                goldenFact={goldenFact}
                onClose={closeGoldenModal}
                onRedeem={redeemTicket}
                backdropClassName={styles.gameModalBackdrop}
            />

            <WinModal
                isOpen={isGameCompleted && (config?.showWinModal ?? true)}
                winCta={config?.winCta}
                hasTicket={hasTicket}
                goldenFact={goldenFact}
                matchedPairsCount={matchedPairsCount}
                totalPairsCount={totalPairsCount}
                attempts={attempts}
                onRedeem={redeemTicket}
                onRestart={resetGame}
                backdropClassName={styles.gameModalBackdrop}
                cardColorType={config?.cardColorType}
                cardCustomColor={config?.cardCustomColor}
            />
        </div>
    );
};

export default MemoryGameContainer;
